import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import visitTracker from './utils/visitTracker'
import request from './utils/request'

Vue.config.productionTip = false

// 挂载 axios 到 Vue 原型
Vue.prototype.$axios = request

// 先安装 ElementUI
Vue.use(ElementUI)

// 创建路由实例
const app = new Vue({
    router,
    render: h => h(App)
})

// 安装访问追踪插件
Vue.use(visitTracker)

// 挂载应用
app.$mount('#app') 